import type { FunctionComponent, ReactNode } from 'react';

import { Box, Card, Center, Flex } from '@mantine/core';
import { StarDivider } from 'primitives/StarDivider';

import { ChowNowStackLogoInk } from '@chownow/pantry/logos';
import { Footer } from 'components/Footer';
import Terms from 'containers/UserAuth/Terms/Terms';

type CardPageShellProps = {
  children: ReactNode;
  /** Card max width. Defaults to the 600 used by the anonymous auth screens. */
  maw?: number;
  /** CPRA footer, centered below the card on the blue background. */
  showFooter?: boolean;
  showStars?: boolean;
  showTerms?: boolean;
};

export const CardPageShell: FunctionComponent<CardPageShellProps> = ({
  children,
  maw = 600,
  showFooter = false,
  showStars = true,
  showTerms = false,
}) => (
  <Flex
    bg="var(--surface-paper-3)"
    pt="xl"
    pb="80"
    mih="calc(100vh)"
    px="sm"
    direction="column"
    align="center"
  >
    <Box w="100%" miw={328} maw={maw}>
      <Center>
        <ChowNowStackLogoInk />
      </Center>
      <Card mt="xl" py="xl" px={{ base: 'md', md: 'xl' }}>
        {showStars && (
          <Box mb={{ base: 'md', md: 'xl' }}>
            <StarDivider />
          </Box>
        )}
        {children}
        {showStars && (
          <Box mt={{ base: 'md', md: 'xl' }}>
            <StarDivider />
          </Box>
        )}
        {showTerms && (
          <Center mt="md">
            <Terms />
          </Center>
        )}
      </Card>
    </Box>
    {showFooter && (
      <Box mt="auto" pt="xl">
        <Footer align="center" />
      </Box>
    )}
  </Flex>
);
